import React, { Component } from 'react';
import ForgotPasswordForm from './forgot-password/ForgotPasswordForm';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import fetchDux from '../../state/fetch-dux';
import Layout from '../ui/Layout';
import MetaTags from 'react-meta-tags';
import { Link } from 'react-router-dom';
import MetaLoader from '../ui/MetaLoader';

class ForgotPasswordRoute extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.clearPostForgotPassword();
    document.body.classList.add(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-login',
      'page-template-page-templatesshop-login-php',
      'page',
      'page-id-240',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  componentWillUnmount() {
    this.props.clearPostForgotPassword();
    document.body.classList.remove(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-login',
      'page-template-page-templatesshop-login-php',
      'page',
      'page-id-240',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  render() {
    const {
      postForgotPassword,
      result,
      error,
      inProgress
    } = this.props;

    const scrollToTop = () => window.scrollTo(0, 0);
    const handlePostForgotPassword = values =>
      postForgotPassword(values, 'forgot-password-form', null, scrollToTop);

    const { success } = result || {};

    return (
      <Layout>
        <MetaLoader title="Forgot Password | Twomey" />
        <MetaTags>
          <title>Forgot Password | Twomey</title>
          <meta property="og:site_name" content="Twomey.com" />
          <meta property="og:title" content="Forgot Password | Twomey" />
          <meta property="og:type" content="article" />
          <meta
            property="og:url"
            content="https://twomey.com/account/forgot-password"
          />
        </MetaTags>
        <div id="content" className="site-content">
          <div id="primary" className="content-area">
            <main
              id="main"
              className="site-main shop-page nohero extra cart-page"
            >
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-10">
                    {!success &&
                      <div className="row">
                        <div className="col-md-12">
                          <h1 className="shop-large">Forgot Password</h1>
                          <p>
                            If you have forgotten your password, enter your email address below and we will send you a link to reset it.
                          </p>
                          <br />
                        </div>
                        <div className="col-md-6">
                          <div className="login-box-left">
                            <ForgotPasswordForm
                              onSubmit={handlePostForgotPassword}
                              passwordError={error}
                            />
                          </div>
                        </div>
                      </div>}
                    {success &&
                      <div className="row">
                        <div className="col-md-12">
                          <h1 className="smaller">Forgot Password</h1>
                          <p>
                            A link to reset your password has been sent to the email provided.
                          </p>
                          <br />
                        </div>
                        <div className="col-md-6">
                          <div className="login-box-left">
                            <Link className="btn btn-primary" to="/">
                              Go to Homepage
                            </Link>
                          </div>
                        </div>
                      </div>}
                  </div>
                </div>
              </div>
            </main>
          </div>
          <div className="container text-right">
            <a href="#top" className="back-to-top" onClick={scrollToTop}>
              Back to top
            </a>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapState = state => {
  const {
    result,
    error,
    inProgress
  } = state.postForgotPassword.toJS();

  return {
    result,
    error,
    inProgress
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      postForgotPassword: fetchDux.postForgotPassword.createAction,
      clearPostForgotPassword: fetchDux.postForgotPassword.clearAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(ForgotPasswordRoute);
